/* eslint-disable jsx-a11y/label-has-associated-control */
import './ToggleButton.scss'
import { type ChangeEvent, type VFC } from 'react'

import { event } from 'shared/experiments/utils/event'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'

type ToggleButtonProps = {
  name: string
  value: boolean
  onChange?: (value: boolean) => void
}

const ToggleButton: VFC<ToggleButtonProps> = ({
  name,
  value,
  onChange = () => null,
}) => {
  const onChangeHandler = (ev: ChangeEvent<HTMLInputElement>) => {
    const checked = ev.target.checked
    onChange(checked)
    trackOptimizelyEvent(event`Now Widget Toggle Clicked`)
  }

  return (
    <div className="o-ToggleButton">
      <input
        onChange={onChangeHandler}
        type="checkbox"
        name={name}
        checked={value}
        className="o-ToggleButton__input"
        id={name}
      />
      <label htmlFor={name} />
    </div>
  )
}

export default ToggleButton
